module.exports = __webpack_public_path__ + "f69e7582e5e851967942bbf3dc2f5075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/visitor/four/four-bg.jpg
// module id = 1268
// module chunks = 0